import React, { useEffect, useState } from "react"
import { CheckBoxImg } from "./styled"

const CheckBox = ({id, state, setItem}) => {
  const [checked, setChecked] = useState(false)

  const onClickCheckBox = () => {
    setChecked(!checked)
    setItem({ id, state, checked: !checked })
  }


  return (
    checked ?
    <CheckBoxImg disabled={false} onClick={() => onClickCheckBox()} src={require('../../../../assets/images/checkbox_on.svg')} />:
    <CheckBoxImg disabled={false} onClick={() => onClickCheckBox()} src={require('../../../../assets/images/checkbox_off.svg')} />
  )
}

export default CheckBox
